export class UpdateUserRequest {
    public userId: string;
    public name: string;
    public email: string;
    public roleId: string;
    public clientId: string;
    public createdBy: string;
    public isDisabled: boolean;
}
